<template>
  <div class="w-full  flex flex-col">
    <h4 class="psui-text-h5 psui-text-gray-80 font-bold whitespace-no-wrap">
      Top jurisdictions with policies
    </h4>
    <div class="block w-full">
      <ApexChartGeneral 
        :options="getChartOptions()"
        :palette-color-index="0"
      />
    </div>
  </div>
</template>

<script>
import { colors } from '@/business-logic/constants/chartDefaultOptions'
import MathFunctions from '@/util/MathFunctions'
export default {
  name: 'AdminDashboardTopJurisdiction',
  data() {
    return {
      colors,
      top_jurisdictions_with_policies: []
    }
  },
   computed: {
    
    getTotal() {
      return this.top_jurisdictions_with_policies.reduce((acc, item) => acc + parseInt(item.policies_count), 0)
    },

    getChartSeries() {
      const data = this.top_jurisdictions_with_policies.map((jurisdiction, index) => {
        return {
          x: `${jurisdiction.title} (${jurisdiction.policies_count})`,
          y: jurisdiction.policies_count,
          jurisdiction,
          fillColor: this.colors[index]
        }
      })
      return [{ data }]
    }
  },

  mounted() {
    this.getData()
  },

  methods: {

    getData() {
      this.$api.get('/api/admin/dashboard/get_data/top_jurisdictions_with_policies')
        .then(({ data }) => {
          this.top_jurisdictions_with_policies = data.top_jurisdictions_with_policies
        })
    },

    getChartOptions() {
      const self = this
      return { 
        chart: {
          type: 'bar',
          stacked: false,
        },
        series: this.getChartSeries, 
        yaxis: {
          labels: {
            formatter: function(value) {
              return self.formatUnits(value)
            }
          },
        },
        tooltip: {
          custom: function ({ seriesIndex, dataPointIndex }) {
            const item = self.getChartSeries[seriesIndex].data[dataPointIndex]
            return `
              <div class="psui-flex" style="background-color: ${ item.fillColor } !important;">
                <div class="apexcharts-tooltip-content psui-w-full psui-bg-white psui-p-4">
                  <h4 class="psui-text-gray-80 psui-text-xsmall psui-font-bold">${ item.jurisdiction.title } ${item.jurisdiction.type}</h4>
                  <div class="psui-w-full psui-flex psui-items-center justify-between space-x-2">
                    <h2 class="psui-text-gray-80 psui-text-small">${ self.formatUnits(item.jurisdiction.policies_count) } Policies</h2>
                    <span class="psui-text-gray-30 psui-mx-1">|</span>
                    <h2 class="psui-text-gray-50 psui-text-small">${ self.formatNumber(MathFunctions.getPercentageOfAmount(self.getTotal, item.jurisdiction.policies_count)) }%</h2>
                  </div>
                </div>
              </div>
            `
          }
        }
      }
    }
  }
}
</script>